module.exports = __webpack_public_path__ + "Icono_FacturacionMenu_126px.png";